import {
  Avatar,
  AvatarFallback,
  Heading,
  Icon,
  TextField,
} from "@elaniintc/goes-design-system";
import { VersionDropdown } from "./VersionDropdown";
import { SectionList } from "./SectionList";
import { useEntity } from "../context";
import { SectionListView } from "./SectionListView";
import { useNavigate } from "react-router";
import { RolesList } from "./RolesList";

export const EditorSection = () => {
  const { entityTitle, setEntityTitle, entityVersions, entityVersion } =
    useEntity();
  const navigate = useNavigate();
  return (
    <div className="flex flex-col flex-1 md:flex-row gap-3 p-8">
      <div className="w-full md:w-1/2">
        <div className="p-4 flex flex-col gap-4">
          <Avatar>
            <AvatarFallback>
              <Icon type="fas" name="folder" className="text-action-quiet" />
            </AvatarFallback>
          </Avatar>
          <Heading variant="h5" color="loud" className="truncate">
            {entityTitle || ""}
          </Heading>
          <hr className="border-neutral-quiet" />
          <SectionListView />
        </div>
      </div>
      <div className="w-full grow md:w-1/2 bg-neutral-object border border-neutral-quiet rounded-lg">
        <div className="border-b border-neutral-quiet">
          <div className="flex justify-between items-center gap-2 px-4 py-2">
            <p className="leading-3xl text-body-loud font-semibold truncate">
              {entityTitle || ""}
            </p>
            <div className="flex items-center gap-2">
              <p className="text-body-quiet text-size-body-sm truncate">
                Guardar creará una nueva versión
              </p>
              <VersionDropdown
                version={entityVersion}
                versions={entityVersions}
                onVersionSelect={(version) => {
                  navigate(`/expedientes/entidad/${version.id}`);
                }}
              />
            </div>
          </div>
        </div>
        <div className="px-2">
          <div className="px-2 py-3">
            <TextField
              label="Título de la entidad"
              required
              placeholder="Escribe el nombre de la entidad"
              value={entityTitle}
              onChange={(e) => setEntityTitle(e.target.value)}
            />
            <RolesList label="Roles" placeholder="Añade un nuevo item" />
            <SectionList />
          </div>
        </div>
      </div>
    </div>
  );
};
